import { apiRequest } from '@/utils/apiRequest'
import { apiUrl } from '@/utils/apiUrl'

class MenuRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async getAvailableMenus() {
		const { data } = await apiRequest({
			url: apiUrl('/world/api/menu/get'),
			method: 'POST',
			body: null,
			token: null,
			expect: 'json',
			throwOnNonOk: true
		})

		return data
	}

	async getAvailableMenuProducts() {
		const { data } = await apiRequest({
			url: apiUrl('/world/api/product/menu/get'),
			method: 'POST',
			body: null,
			token: null,
			expect: 'json',
			throwOnNonOk: true
		})

		return data
	}

	async updateMenuProduct(menuProduct) {
		try {
			console.log('Si todo va bien actualizamos menuProduct ', menuProduct)
			const response = await apiRequest({ url: apiUrl('/world/api/product/menu/update'), method: 'POST', body: { menuProduct }, throwOnNonOk: false })
			if (!response.ok) return response.status
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal actualizando el producto menú.')
		}
	}

	async sendReview(data) {
		try {
			console.log('Enviamos la review ', data)
			const response = await apiRequest({ url: apiUrl('/world/api/review/create'), method: 'POST', body: data, throwOnNonOk: false })
			if (!response.ok) return response.status
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal creando la review.')
		}
	}

	async addTextToReview(data) {
		try {
			console.log('Enviamos el texto para la review ', data)
			const response = await apiRequest({ url: apiUrl('/world/api/review/addtext'), method: 'POST', body: data, throwOnNonOk: false })
			if (!response.ok) return response.status
			return response.data
		} catch (e) {
			console.log('Ups, algo ha ido mal actualizando la review.')
		}
	}

	registerClickReview(data) {
		console.log('Enviamos el click para la review ', data)
		apiRequest({ url: apiUrl('/world/api/review/update'), method: 'POST', body: data, throwOnNonOk: false })
			.then((response) => console.log(response.data))
			.catch(() => console.log('Ups, algo ha ido mal actualizando la review.'))
	}
}

export const menuRepository = new MenuRepository()
